import React from 'react';
import InlineModal from '../../shared/InlineModal';
import PageObjectsStatsTable from './PageObjectsStatsTable';

type BrokenResourcesTableProps = {
    title: string;
    brokenResources: any[];
};

function BrokenResourcesTable({ title, brokenResources }: BrokenResourcesTableProps) {
    return (
        <div className="image-table-container broken-resources">
            <span className="title">{title}</span>
            <div className="image-table">
                <div className="image-table-row header">
                    <div className="image-table-cell url">Url</div>
                    <div className="image-table-cell type">Type</div>
                    <div className="image-table-cell status">Status</div>
                </div>

                {brokenResources.map((brokenResource, idx) => {
                    // const url =
                    //   broken_resource["url"].length > 63
                    //     ? broken_resource["url"].slice(0, 30) + "..." + broken_resource["url"].slice(-30)
                    //     : broken_resource["url"];
                    return (
                        <div
                            className="image-table-row"
                            key={idx}
                        >
                            <div className="image-table-cell url">
                                <div className="truncated">
                                    <a
                                        href={brokenResource.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {brokenResource.url}
                                    </a>
                                </div>
                            </div>
                            <div className="image-table-cell">{brokenResource.resource_type}</div>
                            <div className="image-table-cell">{brokenResource.status}</div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

type Props = {
    pageObjects: {
        broken_resources: {
            same_domain: any[];
            other_domain: any[];
        };
        css: string[];
        font: string[];
        html: string[];
        image: string[];
        javascript: string[];
        other: string[];
        requests_by_domain: {
            data: {
                domain: string;
                requests_count: number;
            }[];
            total: number;
        };
        requests_by_type: {
            data: {
                resource_type: string;
                requests_count: number;
            }[];
            total: number;
        };
        size_by_domain: {
            data: {
                domain: string;
                size: number;
            }[];
            total: number;
        };
        size_by_type: {
            data: {
                resource_type: string;
                size: number;
            }[];
            total: number;
        };
    };
};

export default function Result({ pageObjects }: Props) {
    const titles = {
        size_by_type: 'Content size by content type',
        requests_by_type: 'Requests by content type',
        size_by_domain: 'Content size by domain',
        requests_by_domain: 'Requests by domain',
    };
    const columns = {
        size_by_type: ['Content type', 'Percent', 'Size'],
        requests_by_type: ['Content type', 'Percent', 'Requests'],
        size_by_domain: ['Domain', 'Percent', 'Size'],
        requests_by_domain: ['Domain', 'Percent', 'Requests'],
    };

    let brokenResourcesFromSameDomainCount = 0;
    if ('broken_resources' in pageObjects && 'same_domain' in pageObjects.broken_resources) {
        brokenResourcesFromSameDomainCount = pageObjects.broken_resources.same_domain.length;
    }

    let brokenResourcesFromOtherDomainCount = 0;
    if ('broken_resources' in pageObjects && 'other_domain' in pageObjects.broken_resources) {
        brokenResourcesFromOtherDomainCount = pageObjects.broken_resources.other_domain.length;
    }

    const brokenResourcesCount = brokenResourcesFromSameDomainCount + brokenResourcesFromOtherDomainCount;

    return (
        <div className="description-meta">
            {brokenResourcesCount > 0 && (
                <InlineModal
                    className="broken-resources"
                    openLabel={`We've found ${brokenResourcesCount} broken resource ${brokenResourcesCount > 1 ? 'URLs' : 'URL'}!`}
                    modalTitle="Full list of broken resource Urls"
                    closeLabel="Close"
                >
                    {brokenResourcesFromSameDomainCount > 0 && (
                        <BrokenResourcesTable
                            title="From same domain:"
                            brokenResources={pageObjects.broken_resources.same_domain}
                        />
                    )}
                    {brokenResourcesFromOtherDomainCount > 0 && (
                        <BrokenResourcesTable
                            title="From other domains:"
                            brokenResources={pageObjects.broken_resources.other_domain}
                        />
                    )}
                </InlineModal>
            )}

            <div className="stats-table">
                <div className="stats-table-row">
                    <PageObjectsStatsTable
                        title={titles.size_by_type}
                        columns={columns.size_by_type}
                        result={pageObjects.size_by_type}
                    />
                    <PageObjectsStatsTable
                        title={titles.requests_by_type}
                        columns={columns.requests_by_type}
                        result={pageObjects.requests_by_type}
                    />
                </div>
                <div className="stats-table-row">
                    <PageObjectsStatsTable
                        maxRows={10}
                        title={titles.size_by_domain}
                        columns={columns.size_by_domain}
                        result={pageObjects.size_by_domain}
                    />
                    <PageObjectsStatsTable
                        maxRows={10}
                        title={titles.requests_by_domain}
                        columns={columns.requests_by_domain}
                        result={pageObjects.requests_by_domain}
                    />
                </div>
            </div>
        </div>
    );
}
